import React from 'react'
import MyPayroll from './MyPayroll'


export default function StudentStrengthGraph() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
